import React from "react";
import { useDispatch } from "react-redux";
import { MainModal } from "../../../../components/modal/MainModal";
import { deleteNotification, resetFilters } from "../redux/notificationsSagas";

export const Delete = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const primaryBtnHandler = () => {
    dispatch(deleteNotification());
    close();
  };

  let close = () => {
    dispatch(resetFilters());
    onClose();
  };

  return (
    <MainModal
      isOpen={isOpen}
      containerClassName="dialog"
      width={400}
      height={145}
      primaryButtonText="Yes"
      primaryButtonColor="danger"
      primaryBtnHandler={() => primaryBtnHandler()}
      secondaryBtnText="No"
      secondaryBtnHandler={() => close()}
      onClose={() => close()}
    >
      Are you sure to delete notification?
    </MainModal>
  );
};
